export const useOrganizationStore = defineStore("organization", () => {
  const getCurrentOrganizationFetch = useGetCurrentOrganization();
  const currentOrganization = computed(
    () =>
      unref(getCurrentOrganizationFetch.data.value) as
        OrganizationInfo | undefined,
  );
  const isLoadingOrganization = computed(
    () => getCurrentOrganizationFetch.pending.value,
  );

  function refreshCurrentOrganization() {
    return getCurrentOrganizationFetch.safeFetch();
  }

  function resetCurrentOrganization() {
    return getCurrentOrganizationFetch.reset();
  }

  return {
    isLoadingOrganization,
    currentOrganization,
    refreshCurrentOrganization,
    resetCurrentOrganization,
  };
});
